import React from 'react';
import style from './style.scss';
import logo from '../../assets/images/logo.svg';


export default () => (
  <div className="companyInfoPanel">
    <img src={logo} className="companyInfoLogo"/>
    <p className="companyInfoText">Kratos is a civic startup from New York City using technology to make it easier to get involved in the political process.</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/company-info/index.js